import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFullPage from 'vue-fullpage.js'
import iframeResize from 'iframe-resizer/js/iframeResizer'

Vue.config.productionTip = false
Vue.use(VueFullPage)
Vue.directive('resize', {
  bind: function(el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  },
  unbind: function(el) {
    el.iFrameResizer.removeListeners()
  },
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
